import LegalDocument from './LegalDocument';
import { PRIVACY_POLICY, PRIVACY_VERSION } from './privacyPolicyContent';

/** 개인정보처리방침 페이지 (footer /privacy-policy). */
const PrivacyPolicy = () => {
    return (
        <LegalDocument
            title="개인정보처리방침"
            version={PRIVACY_VERSION}
            content={PRIVACY_POLICY}
        />
    );
};

export default PrivacyPolicy;
